import { SLOTS } from 'types';

export enum ACTIONS {
  PLACE_BET = 'PLACE_BET',
  UPDATE_PLACED_BETS = 'UPDATE_PLACED_BETS',

  CLEAR_ALL_BETS = 'CLEAR_ALL_BETS',

  ADD_CONFIRMED_BET = 'ADD_CONFIRMED_BET',
  SET_CONFIRMED_BET = 'SET_CONFIRMED_BET',

  CANCEL_ALL_BETS = 'CANCEL_ALL_BETS',
  CANCEL_LAST_BET = 'CANCEL_LAST_BET',
}

export type BetSlotType = {
  slot: SLOTS;
  value: number;
};

export type BetType = {
  [key in SLOTS]: number;
};

export interface IConfirmedBet {
  type: string;
  bet: number;
}

export interface IBets {
  past: BetType[] | [];
  present: BetType;
}

export interface IBetState {
  bets: {
    placed: IBets;
    confirmed: IConfirmedBet[];
  };
}
